import request from "./request";
export default {
  request,
  onImgLoading(func) {
    this.onImgLoaded(func, func);
  },
  onImgLoaded(func, checkFunc) {
    let imgs = Array.from(document.querySelectorAll("img")).filter(
      (v) => !v.complete
    );
    if (imgs.length) {
      let c = 0;
      let pros = imgs.map((v) => {
        return new Promise((resolve) => {
          v.onload = () => {
            if (c % 3 === 0) {
              typeof checkFunc === "function" && checkFunc();
            }
            c++;
            resolve();
          };
        });
      });
      pros.push((resolve, reject) => {
        setTimeout(() => reject(), 6000);
      });
      Promise.all(pros)
        .then(() => {
          setTimeout(() => {
            console.log("ok");
            typeof func === "function" && func();
          }, 400);
        })
        .catch(() => {
          setTimeout(() => {
            console.log("err ok");
            typeof func === "function" && func();
          }, 400);
        });
    } else {
      setTimeout(() => {
        console.log("ok");
        typeof func === "function" && func();
      }, 400);
    }
  },
  /**
   * 获取url上在参数
   * @param {*} name
   * @returns
   */
  getQueryString(name) {
    let reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
    let r = window.location.search.substr(1).match(reg);
    if (r != null) {
      return decodeURIComponent(r[2]);
    }
    return null;
  },
  /**
   * 节流
   * @param {*} fn
   * @param {*} interval
   */
  throttle(fn, interval = 400) {
    let _lastTime = null;
    return function() {
      let _nowTime = +new Date();
      if (_nowTime - _lastTime > interval || !_lastTime) {
        fn.call(this, arguments[0]);
        _lastTime = _nowTime;
      }
    };
  },
  /**
   * 函数防抖
   * @param fn 需要进行防抖操作的事件函数
   * @param interval 间隔时间
   * @returns {Function}
   */
  debounce(fn, interval) {
    let timer;
    let gapTime = interval || 400; //间隔时间，如果interval不传，则默认1000ms
    return function() {
      clearTimeout(timer);
      let context = this;
      let args = arguments[0]; //保存此处的arguments，因为setTimeout是全局的，arguments无法在回调函数中获取，此处为闭包。
      timer = setTimeout(function() {
        fn.call(context, args); //args是事件处理函数默认事件参数event  call绑定当前page对象
      }, gapTime);
    };
  },

  /**
   * 千分位转化
   */
  thousandth(num) {
    return (num + "").replace(/(\d{1,3})(?=(\d{3})+(?:$|\.))/g, "$1,");
  },

  // 去除空格转大写
  removeSpacesAndConvertToUpper(str) {
    if (!str) return "";

    const trimmedStr = str.replace(/\s/g, "");
    const upperCaseStr = trimmedStr.toUpperCase();
    return upperCaseStr;
  },
};
